import { SyncStatus } from '../apps/professional-app/fa/MeetingSummary/ExternalUpdates/models'

export enum AIAgentType {
  MEETING_PREPARATION = 'meetingPreparation',
  SUGGESTED_WORKFLOW = 'suggestedWorkflow',
  MEETING_SUMMARY = 'meetingSummary',
  CONTACT_INFORMATION = 'contactInformation',
  EMAIL_RESPONSE_V2 = 'emailResponseV2',
  ASK_ANYTHING = 'askAnything',
  FORM = 'form',
  CLIENT_FORM = 'clientForm',
  CONTACT_UPDATE = 'contactUpdate',
  CONTACT_CREATE = 'contactCreate',
  EMAIL_CONTACT_UPDATE = 'emailContactUpdate',
  NEW_EMAIL = 'newEmail',
  EMAIL_CONTACT_CREATE = 'emailContactCreate',
  FORM_CITATION = 'formCitation',
  DOCUMENT_SUMMARY = 'documentSummary',
  DOCUMENT_TYPE_CALCULATION = 'documentTypeCalculation',
  MEETING_AGENDA = 'meetingAgenda',
  DOCUMENT_CONTACT_UPDATE = 'documentContactUpdate',
  DOCUMENT_PROSPECTING_BASE_FORM_VALUE_GENERATION = 'documentProspectingBaseFormValueGeneration',
  DOCUMENT_PROSPECTING_DETAILS_FORM_VALUE_GENERATION = 'documentProspectingDetailsFormValueGeneration',
  TEMPLATE_GENERATOR = 'templateGenerator',
}

export interface BaseAIAgentExecutionResult {
  aiAgentId: string
  result: { [key: string]: any }
}

export interface AIAgentExecutionResult<T extends { [key: string]: any }> extends BaseAIAgentExecutionResult {
  result: T
}

export interface BaseAIAgentInteractionResult {
  newAiAgentId: string | null
  result: { [key: string]: any }
}

export interface AIAgentInteractionResult<T extends { [key: string]: any }> extends BaseAIAgentInteractionResult {
  result: T
}

export interface AIAgentMessage {
  type: 'user' | 'agent'
  message: string
}

export interface AIAgentInteractionResultType {
  result: any
  timestamp: string
}

export interface AIAgentInteraction {
  aiAgentId: string
  interactions: AIAgentInteractionResultType[]
}

export interface AIAgentResult {
  id: string
  resultKey: string
  originalAiAgentId: string
  result: { [key: string]: any }
  interaction: AIAgentInteraction | null
  updatedAt: string
  createdAt: string
  updatedBy: { type: string; id: string }
  metadata: string
  syncStatus: SyncStatus[]
}
